import { t } from "@/i18n-js/instance";
import circleAIBotAvatar from "../../assets/icons/CircleAIBot-avatar.png";

export const BotAvatar = () => (
  <div className="flex size-4 shrink-0 justify-center overflow-hidden rounded-full">
    <img
      src={circleAIBotAvatar}
      alt={t("help_widget.home_page.copilot_alt")}
      className="size-full object-contain"
      loading="eager"
    />
  </div>
);
